<div mat-dialog-content>
    <mat-progress-spinner
    class=""
    [color]="color"
    [mode]="mode">
</mat-progress-spinner>
<h1>Cargando.</h1>
</div>
